<template lang="html">
  <div class="slider" v-if="loaded">
    <img class="slide-image" :src="slideImage" />
    <h2 class="slide-cta__title">
      {{ slideTitle }}
    </h2>
    <h3 v-if="!replaceSlider" class="slide-cta__description">
      <i18n path="loginCarousel.slideText">
        <template v-slot:slideLinkText>
          <a href="https://www.prostream.app/?utm_source=Docstream&utm_medium=login_page&utm_campaign=ds_login" target="_blank">{{ $t('loginCarousel.slideLinkText') }}</a>
        </template>
      </i18n>
    </h3>
    <h3 v-if="replaceSlider" class="slide-cta__description">
      {{ slideDescription }}
    </h3>
    <hr>
  </div>
</template>

<script>
import * as settingsApi from 'api/settingsApi'

export default {
  name: 'LoginCarousel',
  data () {
    return {
      slideTitle: this.$t('loginCarousel.slideTitle'),
      slideDescription: '',
      slideImage: require('img/login/carousel/slide-1.png'),
      replaceSlider: false,
      loaded: false
    }
  },
  created () {
    let self = this
    const loginSliderImage = 'LoginSliderImage'
    const loginSliderHeader = 'LoginSliderHeader'
    const loginSliderDescription = 'LoginSliderDescription'
    const param = `?values=${loginSliderImage}&values=${loginSliderHeader}&values=${loginSliderDescription}`
    const fileUrl = '/api/server/customerdata/'

    settingsApi.getCustomerDataSettingsList(param).then(result => {
      let newSlideTitle = ''
      let newSlideDescription = ''
      let newSlideImage = ''

      result.forEach(element => {
        if (element.isCustom) {
          self.replaceSlider = true
          if (element.Name === loginSliderImage) {
            newSlideImage = fileUrl + element.Value
          } else {
            if (element.Name === loginSliderHeader) {
              newSlideTitle = element.Value
            } else {
              newSlideDescription = element.Value
            }
          }
        }
      })
      if (self.replaceSlider) {
        self.slideTitle = newSlideTitle
        self.slideDescription = newSlideDescription
        self.slideImage = newSlideImage
      }
      self.loaded = true
    }).catch(() => {
      self.loaded = true
    })
  }
}
</script>

<style lang="scss">
a {
  text-decoration: underline !important;
}
</style>



// WEBPACK FOOTER //
// src/components/login/carousel.vue